import React from 'react';
import { JUPAS_SIX_ROW_LIST_MIN_HEIGHT_CLASS } from '../../utils/jupasLayoutDisplay';

/**
 * 60/40 split: programme list (left) + detail panel (right).
 * Stacks vertically below lg; columns top-align on desktop.
 */
export default function JupasProgrammeSplitLayout({ list, detail, className = '', compact = false }) {
  return (
    <div
      className={`grid min-w-0 grid-cols-1 items-start gap-2 sm:gap-3 lg:grid-cols-[minmax(0,3fr)_minmax(0,2fr)] ${compact ? '' : JUPAS_SIX_ROW_LIST_MIN_HEIGHT_CLASS} ${className}`}
    >
      <div className={`min-w-0 ${compact ? '' : 'min-h-0 overflow-y-auto'}`}>{list}</div>
      <div className={`min-w-0 ${compact ? '' : JUPAS_SIX_ROW_LIST_MIN_HEIGHT_CLASS}`}>{detail}</div>
    </div>
  );
}
